// @flow
import { createSelector } from 'reselect';
import { MOUNT_POINT } from './constants';
import type { State } from './reducer';

export const getTasksState: (state: Object) => State = (state) => state[MOUNT_POINT];

export const getAllTasksCount: (state: State) =>
    Object = createSelector(getTasksState, (state) => state.allTasksCount);
export const getMyTasksCount: (state: State) =>
    Object = createSelector(getTasksState, (state) => state.myTasksCount);
export const getAllCommunicationTasksCount: (state: State) =>
    Object = createSelector(getTasksState, (state) => state.allCommunicationTasksCount);
export const getMyCommunicationTasksCount: (state: State) =>
    Object = createSelector(getTasksState, (state) => state.myCommunicationTasksCount);
